import { sortDirection } from "@interfaces";

export interface IDescription {
    title: string;
    content?: string | null;
}

export interface ISelectFilter {
    id: number | string;
    name: string;
}

export interface IAvailabilityFarePrice {
    productPriceId: number;
    productPricesDetailsId: number;
    productPriceSequence: number;
    agentPricingGroupId: number | null;
    fareTypeId: number;
    fareName: string;
    currencyCode: string;
    fareCurrencyRRP: number | null;
    fareCurrencyNet: number | null;
    RRP: number;
    NetRate: number;
}

export interface IDateRestriction {
    minimumConsecutiveDays: number;
    date: string | null;
    canArrive: string;
    canDepart: string;
}

export interface IAvailFieldOption {
    externalId: string | number;
    name: string | null;
    displayName: string;
    numAvailable: number;
    note: string | null;
}

export interface IAvailField {
    date: string;
    type: string;
    name: string;
    displayName: string;
    options: IAvailFieldOption[];
    required: boolean;
    timeId?: string | number;
}
export interface AvailabilityDateRestriction {
    minimumConsecutiveDays: number;
    date: string | null;
    canArrive: number;
    canDepart: number;
}

export enum AvailabilityType {
    ByRange = "byRange",
    ByProductAndRange = "byProductAndRange",
}

export interface BaseAvailability {
    BookingDate: string;
    BookingTimeID: string | null;
    BookingTime?: string | null;
    NumAvailable: number;
    DateRestriction: AvailabilityDateRestriction | null;
    Note: string | null;
    availabilityType: AvailabilityType;
}

export interface IAvailabilityByRange extends BaseAvailability {
    EndDate: string | null;
    productPricesDetailsId: string | number;
    datePriceCacheId: string | number | null;
    Note: string | null;
    RequiresFurtherDetailsToConfirm: boolean;
    productPricingData: {
        RRP: number;
        NetRate: number;
        FareCurrencyRRP: number;
        FareCurrencyNetRate: number;
        IgnorePpdMargins: boolean;
    };
    fields: IAvailField[];
}

export interface SelectedAvailabilityByRange extends IAvailabilityByRange {
    availIndex: number;
}

export interface IAvailabilityByProductAndRange extends BaseAvailability {
    FarePrice: IAvailabilityFarePrice | null;
}

export interface SelectedAvailabilityByProductAndRange extends IAvailabilityByProductAndRange {
    availIndex: number;
}

export type IBookingAvailability = IAvailabilityByRange | IAvailabilityByProductAndRange;
export type SelectedAvailability =
    | SelectedAvailabilityByRange
    | SelectedAvailabilityByProductAndRange;

export interface IAvailabilityDetailsToConfirm {
    productPricesDetailsId: string | number;
    fields: IAvailField[];
}

export interface IProductAvailOption {
    id: string;
    displayName: string;
    numAvailable: number;
}

export interface IProductAvailFieldOption {
    type: string;
    displayName: string;
    required: boolean;
    options: IProductAvailOption[];
}

export interface IProductAvailTimeOption extends IProductAvailFieldOption {
    date: Date;
}

export interface IProductAvailPickUpOption extends IProductAvailFieldOption {
    timeId: string;
}

export interface IProductAvailDropOffOption extends IProductAvailFieldOption {
    timeId: string;
}

export interface IAvailOptions {
    timeOptions: IProductAvailTimeOption[];
    pickUpOptions: IProductAvailPickUpOption[];
    dropOffOptions: IProductAvailDropOffOption[];
}

export interface IProductAvailability extends IAvailOptions {
    BookingDate: Date;
    productId: string;
    NumAvailable: number;
    productPricesDetailsId: string | null;
    RRP: number | null;
    NetRate: number | null;
    levy: number | null;
    // index of availability
    availIndex: number;
    bookingTimeId: string | null;
}

export interface SortItem {
    title: string;
    value: sortDirection;
}

export interface SortBy {
    key: string;
    value: SortItem[];
}

export interface ISortMenuComponent {
    onSort: (sort: SortBy, id: number) => void;
    isShowSortMenu: boolean;
    titleSort?: string;
}
